import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ProductVariantContainer from '@configuratorware/configurator-frontendgui/App/Shared/Containers/ProductVariant';
import ProductVariant from '../../Components/ProductVariant/ProductVariant';
import { fetchAdditionalData } from '../../Reducers/Configurator/Actions';
import get from 'lodash/get';

const CustomProductVariantContainer = (props) => {
  const dispatch = useDispatch();
  const configuratorState = useSelector((state) => state.configurator);
  useEffect(() => {
    dispatch(fetchAdditionalData());
  }, []);
  const {
    additionalPositionsLoaded,
    configuration: { customdata },
  } = configuratorState;

  return (
    <ProductVariantContainer
      {...props}
      Component={ProductVariant}
      additionalPositionsLoaded={additionalPositionsLoaded}
      seatPositionsData={get(customdata, 'seatPositionsData', {})}
    />
  );
};

export default CustomProductVariantContainer;
